import type React from 'react';
import styles from './board-symbols.module.scss';

/**
 * A star of `points` points centred at (`cx`, `cy`) in a 20 × 20 box: `r` to each point, `inner` of
 * that to each notch between them.
 */
const starPath = (cx: number, cy: number, r: number, points: number, inner: number) =>
  `${Array.from({ length: points * 2 }, (_, i) => {
    const angle = ((-90 + (i * 180) / points) * Math.PI) / 180;
    const radius = i % 2 === 0 ? r : r * inner;
    return `${i === 0 ? 'M' : 'L'}${(cx + radius * Math.cos(angle)).toFixed(2)} ${(cy + radius * Math.sin(angle)).toFixed(2)}`;
  }).join('')}Z`;

/** Where the sparkles sit: a diagonal pair for double word, a triangle for triple, apart so their points don't cross. */
const SPARKLE_LAYOUT: Record<2 | 3, { cx: number; cy: number; r: number }[]> = {
  2: [
    { cx: 6, cy: 6.4, r: 5.2 },
    { cx: 14, cy: 13.6, r: 5.2 },
  ],
  3: [
    { cx: 10, cy: 4.6, r: 4.4 },
    { cx: 4.6, cy: 14.4, r: 4.4 },
    { cx: 15.4, cy: 14.4, r: 4.4 },
  ],
};

/** A word premium's mark: two four-point sparkles for double word, three for triple. */
export const Sparkles: React.FC<{ count: 2 | 3 }> = ({ count }) => (
  <svg className={styles.symbol} viewBox="0 0 20 20" aria-hidden="true">
    {SPARKLE_LAYOUT[count].map(({ cx, cy, r }) => (
      <path key={`${cx},${cy}`} d={starPath(cx, cy, r, 4, 0.34)} className={styles.fill} />
    ))}
  </svg>
);

/** Radii of the start square's three rings, outermost first. */
const START_RINGS = [8.2, 5.4, 2.6];

/** The start square's mark: three concentric rings, a target — where the opening word goes. */
export const StartRings: React.FC = () => (
  <svg className={styles.symbol} viewBox="0 0 20 20" aria-hidden="true">
    {START_RINGS.map((r) => (
      <circle key={r} cx={10} cy={10} r={r} className={styles.line} />
    ))}
  </svg>
);
